import { render, staticRenderFns } from "./DIASRealEstateDocuments.vue?vue&type=template&id=23cf3ab2&scoped=true&"
import script from "./DIASRealEstateDocuments.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateDocuments.vue?vue&type=script&lang=js&"
import style0 from "./DIASRealEstateDocuments.vue?vue&type=style&index=0&id=23cf3ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf3ab2",
  null
  
)

export default component.exports